import React, { Component, Suspense, lazy, useContext } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { Context } from "../auth/Context";

import Spinner from "../app/shared/Spinner";
import CauseList from "./dashboard/causeList/CauseListWithSister";
import DisposalCauseList from "./dashboard/causeList/DisposalCauseList";
import CauseListWithoutRegistry from "./dashboard/causeList/CauseListWithoutRegistry";
import CauseListJudgment from "./dashboard/causeList/CauseListJudgmentWithSister";
import CauseListWithPrayer from "./dashboard/causeList/CauseListWithPrayer.js";
import CurrentCauseListWithPrayer from "./dashboard/causeList/CurrentCauseListWithPrayer.js";
import ResaultOfApplicationSearch from "./dashboard/causeList/ResaultOfApplicationSearch.js";
import CauseListWithSisterCustomPrint from "./dashboard/causeList/CauseListWithSisterCustomPrint";
import CauseListCounsel from "./dashboard/causeList/CauseListCounselWithSister";
import CauseListCounselWithSisterArchive from "./dashboard/causeList/CauseListCounselWithSisterArchive";
import CauseListCounselPrint from "./dashboard/causeList/CauseListCounselWithSisterPrint";
import CauseListCounselByPage from "./dashboard/causeList/CauseListCounselPerPage";
import CounselList from "./dashboard/causeList/CounselListArchive";
import { AssignedJusticesFullCourt } from "./dashboard/Justices/AssignedJusticesFullCourt.js";
import ChangePwdInApp from "./dashboard/users/ChangePwdInApp.js";
import CauseListWithSisterArchive from "./dashboard/causeList/CauseListWithSisterArchive.js";
import CauseListWithSisterReason from "./dashboard/causeList/CauseListWithSisterReason.js";
import RegistryAssignedCauseListJudgment from "./dashboard/causeList/RegistryAssignedCauseListJudgmentWithSister.js";

import PastCauseListWithSisterReason from "./dashboard/causeList/PastCauseListWithSisterReason.js";
import JudgementCauseListCounsel from "./dashboard/causeList/JudgementCauseListCounselWithSister";

const Appellants = lazy(() => import("./dashboard/appellants/Appellants"));
const Achieve = lazy(() => import("./dashboard/achieve/Dairy.js"));
const SingleAchive = lazy(() => import("../components/SingleAchieve.js"));

const Dashboard = lazy(() => import("./dashboard/Dashboard"));
const CaseInView = lazy(() => import("./dashboard/CaseInView.js"));
const CaseInViewCalendar = lazy(
  () => import("./dashboard/cases/CaseInViewIndex.js"),
);
const NewUser = lazy(() => import("./dashboard/users/NewUser"));
const Users = lazy(() => import("./dashboard/users/Users"));
const AllCases = lazy(() => import("./dashboard/cases/AllCases"));
const ActiveCases = lazy(() => import("./dashboard/cases/ActiveCases"));
const AllCasesSearch = lazy(() => import("./dashboard/cases/AllCasesSearch"));

const CaseDairyHistory = lazy(() => import("./dashboard/cases/CaseHistory"));

const AuditLogReport = lazy(
  () => import("./dashboard/auditLogReport/AuditLogReport.js"),
);
const QuarterlyReport = lazy(
  () => import("./dashboard/quarterlyReport/QuarterlyReport.js"),
);
const AllCaseTypes = lazy(() => import("./dashboard/caseTypes/AllCaseTypes"));
const NewCaseType = lazy(() => import("./dashboard/caseTypes/NewCaseType"));
const RemarkTypeCategory = lazy(
  () => import("./dashboard/remarkTypeCategory/RemarkTypeCategory.js"),
);

const AllRemarkType = lazy(
  () => import("./dashboard/remarkType/AllRemarkType"),
);
const RemarkType = lazy(() => import("./dashboard/remarkType/RemarkType"));

const CasePerDay = lazy(() => import("./dashboard/maximumCase/CasePerDay"));
const CaseDiaryLimit = lazy(
  () => import("./dashboard/maximumCase/CaseDiaryLimit"),
);

const UsersCase = lazy(() => import("./dashboard/cases/UsersCase"));
const UserCases = lazy(() => import("./dashboard/cases/AllCases"));
const NewCase = lazy(() => import("./dashboard/cases/NewCase"));
const CaseEntry = lazy(() => import("./dashboard/cases/CaseEntry"));

//role management
const Roles = lazy(() => import("./dashboard/roleManagement/Roles"));
const Module = lazy(() => import("./dashboard/roleManagement/Module"));
const SubModules = lazy(() => import("./dashboard/roleManagement/SubModule"));
const AssignModule = lazy(
  () => import("./dashboard/roleManagement/AssignModule"),
);

const SingleCase = lazy(() => import("./dashboard/cases/SingleCase"));
const SingleCaseInview = lazy(
  () => import("./dashboard/cases/SingleCaseInView.js"),
);
const BulkUpload = lazy(() => import("./dashboard/cases/BulkUpload.js"));

const Holidays = lazy(() => import("./dashboard/Holidays/Holidays"));
const Justices = lazy(() => import("./dashboard/Justices/Justices"));
const AssignedJustices = lazy(
  () => import("./dashboard/Justices/AssignedJustices"),
);

const NewAssignedJustices = lazy(
  () => import("./dashboard/Justices/NewAssignedJusticeList.js"),
);
const AllActiveAssignCases = lazy(
  () => import("./dashboard/cases/AllActiveCases"),
);
const NewDeactivateJustice = lazy(
  () => import("./dashboard/Justices/NewDeactivateJustice"),
);

const JusticeDateList = lazy(
  () => import("./dashboard/Justices/JusticeDateList"),
);
const DeactivateJustice = lazy(
  () => import("./dashboard/Justices/DeactivateJustice"),
);
const PostSittingDeactivateJustice = lazy(
  () => import("./dashboard/Justices/PostSittingDeactivateJustice"),
);
const MutipleDeactivateJustice = lazy(
  () => import("./dashboard/Justices/MutipleDeactivateJustice.js"),
);
const BailiffCallPage = lazy(
  () => import("./dashboard/bailiffCall/BailiffCall"),
);

const MutipleDeactivateJusticeNew = lazy(
  () => import("./dashboard/Justices/MutipleDeactivateJusticeNew"),
);

// const CaseJusticeList =lazy(()=>import('./dashboard/Justices/CaseJusticeList'))
// const CaseJusticesList =lazy(()=> import('./dashboard/Justices/CaseJusticeList.JS'))

const AssignedJusticeList = lazy(
  () => import("./dashboard/Justices/AssignedJusticeList"),
);
const JusticeDisqualifications = lazy(
  () => import("./dashboard/Justices/JusticeDisqualifications"),
);
const NewJusticeDisqualifications = lazy(
  () => import("./dashboard/Justices/NewJusticeDisqualification.js"),
);
const CaseDiaryCasesDetails = lazy(
  () => import("./dashboard/cases/CaseDiaryCasesDetails.js"),
);

const RegistryCaseInView = lazy(
  () => import("./dashboard/RegistryCaseInView.js"),
);

const CreateHoliday = lazy(() => import("./dashboard/Holidays/CreateHoliday"));

const Buttons = lazy(() => import("./basic-ui/Buttons"));
const Dropdowns = lazy(() => import("./basic-ui/Dropdowns"));
const Typography = lazy(() => import("./basic-ui/Typography"));

const BasicElements = lazy(() => import("./form-elements/BasicElements"));

const BasicTable = lazy(() => import("./tables/BasicTable"));

const Mdi = lazy(() => import("./icons/Mdi"));

const ChartJs = lazy(() => import("./charts/ChartJs"));

const Error404 = lazy(() => import("./error-pages/Error404"));
const Error500 = lazy(() => import("./error-pages/Error500"));

const Login = lazy(() => import("./user-pages/Login"));
const ForgotPassword = lazy(() => import("./user-pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./user-pages/ResetPassword"));
const Register1 = lazy(() => import("./user-pages/Register"));
const Lockscreen = lazy(() => import("./user-pages/Lockscreen"));

const BlankPage = lazy(() => import("./general-pages/BlankPage"));

const AppRoutes = () => {
  const { user, dispatch } = useContext(Context);
  const isAuthenticated = user !== null; // Update this condition based on your authentication logic

  return (
    <Suspense fallback={<Spinner />}>
      <Switch>
        <Route path="/forgetpassword" component={ForgotPassword} />
        <Route path="/login" component={Login} />
        {/* <Route path="/reset-password" component={ResetPassword} /> */}
        <Route path="/reset-password/:token?" component={ResetPassword} />

        {/* Add this condition before rendering each protected route */}
        {isAuthenticated ? (
          <>
            <Route path="/dashboard" component={Dashboard} />
            <Route path="/case-in-view" component={CaseInView} />
            <Route
              path="/case-in-view-calendar"
              component={CaseInViewCalendar}
            />
            <Route path="/dairy-achieve" component={Achieve} />
            <Route path="/dairy-single/:id" component={SingleAchive} />
            <Route path="/basic-ui/buttons" component={Buttons} />
            <Route path="/new-user" component={NewUser} />
            <Route path="/users" component={Users} />
            <Route path="/all-case" component={AllCases} />
            <Route path="/active-cases" component={ActiveCases} />
            <Route path="/all-case-search" component={AllCasesSearch} />
            <Route path="/case-diary-history" component={CaseDairyHistory} />
            <Route path="/audit-log-report" component={AuditLogReport} />
            <Route
              path="/diaries-quarterly-report"
              component={QuarterlyReport}
            />
            <Route path="/upload-cases" component={BulkUpload} />

            <Route
              path="/cause-list-and-reason"
              component={CauseListWithSisterReason}
            />

            <Route
              path="/past-cause-list-and-reason"
              component={PastCauseListWithSisterReason}
            />

            <Route path="/cause-list" component={CauseList} />
            <Route
              path="/cause-list-registry"
              component={CauseListWithoutRegistry}
            />
            <Route path="/disposal-cause-list" component={DisposalCauseList} />
            <Route path="/judgment-cause-list" component={CauseListJudgment} />
            <Route path="/counsel-list-archive" component={CounselList} />
            {/* outcome or result of application */}
            <Route
              path="/cause-list-with-outcome"
              component={CauseListWithPrayer}
            />
            <Route
              path="/current-cause-list-with-outcome"
              component={CurrentCauseListWithPrayer}
            />
            <Route
              path="/cause-list-archive"
              component={CauseListWithSisterArchive}
            />
            <Route
              path="/cause-list-result-search"
              component={ResaultOfApplicationSearch}
            />
            <Route
              path="/cause-list-custom-print"
              component={CauseListWithSisterCustomPrint}
            />
            <Route path="/cause-list-counsel" component={CauseListCounsel} />
            <Route
              path="/cause-list-counsel-print"
              component={CauseListCounselPrint}
            />
            <Route
              path="/cause-list-counsel-archive"
              component={CauseListCounselWithSisterArchive}
            />

            <Route
              path="/cause-list-counsel-per-page"
              component={CauseListCounselByPage}
            />
            <Route path="/case-types" component={AllCaseTypes} />
            <Route path="/new-case-type" component={NewCaseType} />
            <Route
              path="/remark-type-category"
              component={RemarkTypeCategory}
            />
            <Route path="/all-remark-type" component={AllRemarkType} />
            <Route path="/remark-type" component={RemarkType} />
            <Route path="/case-limit" component={CasePerDay} />
            <Route path="/case-diary-limit" component={CaseDiaryLimit} />

            <Route path="/users-cases" component={UsersCase} />
            <Route
              path="/change-authenticated-user-password"
              component={ChangePwdInApp}
            />
            <Route path="/case/:id" component={SingleCase} />
            <Route path="/add-case" component={NewCase} />
            <Route path="/case-entry" component={CaseEntry} />
            <Route path="/edit-case/:caseId" component={NewCase} />
            <Route path="/user-case/:id" component={SingleCase} />
            <Route path="/user-case-inview/:id" component={SingleCaseInview} />
            <Route path="/appellants" component={Appellants} />
            <Route path="/role" component={Roles} />
            <Route path="/module-list" component={Module} />
            <Route path="/submodule-list" component={SubModules} />
            <Route path="/assign-module-to-role" component={AssignModule} />
            <Route path="/Create-holiday" component={CreateHoliday} />
            <Route path="/holidays" component={Holidays} />
            <Route path="/justices" component={Justices} />
            <Route path="/assign-justices" component={AssignedJustices} />
            <Route
              path="/assign-justices-fullcourt"
              component={AssignedJusticesFullCourt}
            />
            <Route
              path="/new-assign-justices"
              component={NewAssignedJustices}
            />
            <Route
              path="/all-active-assign-case"
              component={AllActiveAssignCases}
            />
            <Route
              path="/new-deactivate-justices"
              component={NewDeactivateJustice}
            />
            <Route
              path="/assign-justices-list"
              component={AssignedJusticeList}
            />
            <Route
              path="/assigned-justices-date-list"
              component={JusticeDateList}
            />
            <Route path="/deactivate-justice" component={DeactivateJustice} />
            <Route
              path="/post-sitting-deactivate-justice"
              component={PostSittingDeactivateJustice}
            />
            <Route
              path="/multiple-deactivate-justice"
              component={MutipleDeactivateJustice}
            />

            <Route
              path="/multiple-deactivate-justice-new"
              component={MutipleDeactivateJusticeNew}
            />
            {/* <Route path="/case-justice-list" component={CaseJusticeList} /> */}
            <Route
              path="/justices-disqualifications"
              component={JusticeDisqualifications}
            />
            <Route
              path="/new-justices-disqualifications"
              component={NewJusticeDisqualifications}
            />
            <Route path="/basic-ui/dropdowns" component={Dropdowns} />
            <Route path="/basic-ui/typography" component={Typography} />
            <Route
              path="/form-Elements/basic-elements"
              component={BasicElements}
            />
            <Route
              exact
              path="/bailiff-call/:caseId"
              component={BailiffCallPage}
            />
            <Route
              path="/reg-assigned-judgment-cause-list"
              component={RegistryAssignedCauseListJudgment}
            />
            <Route
              path="/judgement-cause-list-counsel"
              component={JudgementCauseListCounsel}
            />
            <Route
              path="/case-diary-cases-reports"
              component={CaseDiaryCasesDetails}
            />
            <Route path="/registry-case-in-view" component={RegistryCaseInView} />

            <Route path="/tables/basic-table" component={BasicTable} />
            <Route path="/icons/mdi" component={Mdi} />
            <Route path="/charts/chart-js" component={ChartJs} />
            <Route path="/user-pages/login-1" component={Login} />
            <Route path="/user-pages/register-1" component={Register1} />
            <Route path="/user-pages/lockscreen" component={Lockscreen} />
            <Route path="/error-pages/error-404" component={Error404} />
            <Route path="/error-pages/error-500" component={Error500} />
          </>
        ) : (
          <Redirect to="/login" />
        )}
        <Route path="/general-pages/blank-page" component={BlankPage} />
        {/* If none of the above routes match, redirect to the login page */}
        {/* <Redirect to="/general-pages/blank-page" /> */}
      </Switch>
    </Suspense>
  );
};

export default AppRoutes;
